import { Route } from 'react-router-dom';

import { OnboardingCompletionGuard } from '@/app/router/OnboardingCompletionGuard';
import { ProtectedRoute } from '@/app/router/ProtectedRoute';

import { UsersScreen } from './pages/UsersScreen';

export const usersRoutes = (
  <Route
    path="/users"
    element={
      <ProtectedRoute>
        <OnboardingCompletionGuard>
          <UsersScreen />
        </OnboardingCompletionGuard>
      </ProtectedRoute>
    }
  />
);
